import React, { createContext, useState, useEffect } from "react";
import { BehaviorSubject } from "rxjs";
import { getKeycloak, getKeycloakInitOptions } from "../utils/auth";

const AuthContext = createContext<{
  auth: boolean;
  token: string;
  logout: () => void;
}>(null);

export const authSubject = new BehaviorSubject(null);

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(null);
  const [token, setToken] = useState(null);

  const logout = () => {
    const keycloak = getKeycloak();
    if (keycloak) {
      keycloak.logout();
    }
  };

  const deslogaBemsign = () => {
    localStorage.removeItem("sessionToken");
    localStorage.removeItem("user");
    localStorage.removeItem("userAvatar");
  };

  useEffect(() => {
    deslogaBemsign();

    const initKeycloak = async () => {
      const keycloak = getKeycloak();

      const tokenFromStorage = localStorage.getItem("token");
      const refreshTokenFromStorage = localStorage.getItem("refreshToken");
      const idTokenFromStorage = localStorage.getItem("idToken");

      try {
        const authenticated = await keycloak.init({
          ...getKeycloakInitOptions(),
          token: tokenFromStorage ?? null,
          refreshToken: refreshTokenFromStorage ?? null,
          idToken: idTokenFromStorage ?? null,
        });

        if (!authenticated) {
          keycloak.login();
        } else {
          authSubject.next({
            auth: authenticated,
            token: keycloak?.token,
            username:
              keycloak.tokenParsed?.given_name || keycloak.tokenParsed?.preferred_username,
            keycloak: keycloak,
          });

          localStorage.setItem("token", keycloak?.token);
          localStorage.setItem("refreshToken", keycloak?.refreshToken);
          localStorage.setItem("idToken", keycloak?.idToken);
          localStorage.setItem(
            "username",
            keycloak.tokenParsed?.given_name || keycloak.tokenParsed?.preferred_username
          );
        }
      } catch (error) {
        console.error("Falha ao inicializar o Keycloak:", error);
      }
    };

    initKeycloak();

    const subscription = authSubject.subscribe((authObj) => {
      setAuth(authObj?.auth);
      setToken(authObj?.token);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return (
    <AuthContext.Provider value={{ auth, token, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => React.useContext(AuthContext);
